import SettingsMetaData from "../../../../../Components/Hooks/useSettingsMetaData";

const ServiceTypeSurvey = () => {
  return (
    <SettingsMetaData propertyName={"Service_Type_Survey"} viewPropertyName={"Service Type"} />
  );
};
export default ServiceTypeSurvey;